<script lang="ts">
  import Button from "../atoms/Button.svelte";
  import Heading from "../atoms/Heading.svelte";
  import ZipCode from "./ZipCode.svelte";

  interface Props {
    zipcode: string | undefined;
    refetchPrices: () => void;
  }

  let { zipcode = $bindable(), refetchPrices }: Props = $props();

  let valid = $state(false);
</script>

<ZipCode bind:zipcode bind:valid>
  <Heading>Nu gick det fel! Det angivna postnumret finns inte!</Heading>
</ZipCode>

{#if valid}
  <Button onClick={() => refetchPrices()} class="w-full">Hämta pris igen</Button>
{/if}
